App.controller('ZochWorkersDetailsCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', '$filter', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams) {
	$scope.stateParams = $stateParams;

    $scope.data = $scope.stateParams.worker;
    if (!$scope.data) {
        $state.go('root.home.zoch.workers.list');
    }

    console.log($scope.data);

    $scope.page = 'zoch_workers';
    $scope.$emit('page', $scope.page);

    $scope.step = $scope.stateParams.worker.person.firstName + ' ' + $scope.stateParams.worker.person.lastName + ' (dane szczegółowe)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.workers.list';
    $scope.$emit('link', $scope.link);
}]);